module.exports = __webpack_public_path__ + "static/assets/95c0b916b508cfbc403ecd0843b7d80e.png";